module.exports = __webpack_public_path__ + "static/media/1_en.d05cf643.png";